/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Animated, StyleProp, TextStyle, ViewStyle } from "react-native";
import SVG_Svg, {
  ClipPath as SVG_ClipPath,
  Defs,
  G as SVG_G,
  GProps,
  Path as SVG_Path,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const ClipPath = Animated.createAnimatedComponent(SVG_ClipPath);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE">{"tProps":{"type":"PROPS","Frame_201?":{"onPress":"Function"}},"#Frame_201":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.Frame_201?.onPress"}}}</desc>
 * <g id="Cart" clip-path="url(#clip0)">
 * <rect width="27" height="26" fill="white"/>
 * <g id="Cart_2" clip-path="url(#clip1)">
 * <g id="Group">
 * <g id="Group_2">
 * <g id="Group_3">
 * <path id="Vector" d="M8.29418 20.2232C6.79505 20.2232 5.57982 21.4385 5.57982 22.9376C5.57982 24.4367 6.7951 25.652 8.29418 25.652C9.7933 25.652 11.0085 24.4367 11.0085 22.9376C11.0086 21.4385 9.7933 20.2232 8.29418 20.2232ZM8.29418 24.4456C7.46134 24.4456 6.78621 23.7705 6.78621 22.9377C6.78621 22.1048 7.46134 21.4297 8.29418 21.4297C9.12701 21.4297 9.80214 22.1048 9.80214 22.9377C9.80219 23.7705 9.12701 24.4456 8.29418 24.4456Z" fill="#373938"/>
 * <path id="Vector_2" d="M19.7551 20.2232C18.256 20.2232 17.0408 21.4385 17.0408 22.9376C17.0408 24.4367 18.2561 25.652 19.7551 25.652C21.2542 25.652 22.4695 24.4367 22.4695 22.9376C22.4695 21.4385 21.2543 20.2232 19.7551 20.2232ZM19.7551 24.4456C18.9223 24.4456 18.2472 23.7705 18.2472 22.9377C18.2472 22.1048 18.9223 21.4297 19.7551 21.4297C20.588 21.4297 21.2631 22.1048 21.2631 22.9377C21.2632 23.7705 20.588 24.4456 19.7551 24.4456Z" fill="#373938"/>
 * <path id="Vector_3" d="M25.877 4.38943C25.7514 4.25221 25.5796 4.16631 25.3945 4.14813L5.76052 3.87669L5.21765 2.21789C4.83521 1.109 3.7968 0.36039 2.62389 0.347979H0.603196C0.27005 0.347979 0 0.618028 0 0.951174C0 1.28432 0.27005 1.55437 0.603196 1.55437H2.62389C3.27974 1.56886 3.85724 1.98998 4.07159 2.60998L7.90187 14.1612L7.6003 14.8548C7.26393 15.7222 7.36495 16.6985 7.87174 17.4787C8.37368 18.245 9.21812 18.7179 10.1337 18.7454H21.8659C22.199 18.7454 22.4691 18.4754 22.4691 18.1422C22.4691 17.8091 22.199 17.539 21.8659 17.539H10.1337C9.61662 17.5261 9.14065 17.2541 8.86696 16.8152C8.59634 16.3817 8.54075 15.8476 8.71618 15.3675L8.95748 14.8246L21.6547 13.4976C23.0494 13.344 24.1967 12.3296 24.5199 10.9641L25.9676 4.90205C26.0329 4.72748 25.9982 4.53115 25.877 4.38943ZM23.3437 10.6928C23.1479 11.5717 22.4016 12.2201 21.5039 12.2912L8.95748 13.5881L6.15261 5.08309L24.6405 5.35452L23.3437 10.6928Z" fill="#373938"/>
 * </g>
 * </g>
 * </g>
 * </g>
 * </g>
 * <defs>
 * <clipPath id="clip0">
 * <rect width="27" height="26" fill="white"/>
 * </clipPath>
 * <clipPath id="clip1">
 * <rect width="26" height="26" fill="white"/>
 * </clipPath>
 * </defs>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"Frame_201?": "tButtonProps",
 * 		"onAnimationComplete?": "() => void"
 * 	},
 * 	"#Frame_201": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.Frame_201?.onPress",
 * 			"animation": "touchableOpacity"
 * 		}
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  Frame_201?: tButtonProps;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Button Prop Types */

type tButtonProps = {
  onPress: () => void;
} & GProps;
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const Cart = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  Frame_201?: tButtonProps;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const { svgRef } = props;
  /** Component Internal State */

  const [] = React.useState<{
    Frame_201ButtonOpacity: number;
  }>({
    Frame_201ButtonOpacity: 1,
  });


  /***/
  // #endregion

  /** End Button Wrapper */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 27 26" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="Cart" clipPath="url(#clip0)">
        <Path
          fill="white"
          id="Cart_elem0"
          d="M0 0 H27 a0,0 0 0 1 0,0 V26 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <G id="Cart_2" clipPath="url(#clip1)">
          <G id="Group">
            <G id="Group_2">
              <G id="Group_3">
                <Path
                  id="Vector"
                  d="M8.29418 20.2232C6.79505 20.2232 5.57982 21.4385 5.57982 22.9376C5.57982 24.4367 6.7951 25.652 8.29418 25.652C9.7933 25.652 11.0085 24.4367 11.0085 22.9376C11.0086 21.4385 9.7933 20.2232 8.29418 20.2232ZM8.29418 24.4456C7.46134 24.4456 6.78621 23.7705 6.78621 22.9377C6.78621 22.1048 7.46134 21.4297 8.29418 21.4297C9.12701 21.4297 9.80214 22.1048 9.80214 22.9377C9.80219 23.7705 9.12701 24.4456 8.29418 24.4456Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_2"
                  d="M19.7551 20.2232C18.256 20.2232 17.0408 21.4385 17.0408 22.9376C17.0408 24.4367 18.2561 25.652 19.7551 25.652C21.2542 25.652 22.4695 24.4367 22.4695 22.9376C22.4695 21.4385 21.2543 20.2232 19.7551 20.2232ZM19.7551 24.4456C18.9223 24.4456 18.2472 23.7705 18.2472 22.9377C18.2472 22.1048 18.9223 21.4297 19.7551 21.4297C20.588 21.4297 21.2631 22.1048 21.2631 22.9377C21.2632 23.7705 20.588 24.4456 19.7551 24.4456Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_3"
                  d="M25.877 4.38943C25.7514 4.25221 25.5796 4.16631 25.3945 4.14813L5.76052 3.87669L5.21765 2.21789C4.83521 1.109 3.7968 0.36039 2.62389 0.347979H0.603196C0.27005 0.347979 0 0.618028 0 0.951174C0 1.28432 0.27005 1.55437 0.603196 1.55437H2.62389C3.27974 1.56886 3.85724 1.98998 4.07159 2.60998L7.90187 14.1612L7.6003 14.8548C7.26393 15.7222 7.36495 16.6985 7.87174 17.4787C8.37368 18.245 9.21812 18.7179 10.1337 18.7454H21.8659C22.199 18.7454 22.4691 18.4754 22.4691 18.1422C22.4691 17.8091 22.199 17.539 21.8659 17.539H10.1337C9.61662 17.5261 9.14065 17.2541 8.86696 16.8152C8.59634 16.3817 8.54075 15.8476 8.71618 15.3675L8.95748 14.8246L21.6547 13.4976C23.0494 13.344 24.1967 12.3296 24.5199 10.9641L25.9676 4.90205C26.0329 4.72748 25.9982 4.53115 25.877 4.38943ZM23.3437 10.6928C23.1479 11.5717 22.4016 12.2201 21.5039 12.2912L8.95748 13.5881L6.15261 5.08309L24.6405 5.35452L23.3437 10.6928Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
              </G>
            </G>
          </G>
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0">
          <Path
            fill="white"
            id="clip0_elem0"
            d="M0 0 H27 a0,0 0 0 1 0,0 V26 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </ClipPath>
        <ClipPath id="clip1">
          <Path
            fill="white"
            id="clip1_elem0"
            d="M0 0 H26 a0,0 0 0 1 0,0 V26 a0,0 0 0 1 -0,0 H0 a0,0 0 0 1 -0,-0 V0 a0,0 0 0 1 0,-0z"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
/***/

export default React.memo(Cart);
